import { defineStore } from 'pinia'
import { isOnlineByHealthChecker } from '@/modules/healthCheck/healthChecker'

export interface NetworkState {
  /** オンライン状態か（true: オンライン状態） */
  isOnline: boolean
  /** オンラインになれる状態か（true: オンラインになれる状態） */
  canConnectNetwork: boolean
  /** オンラインモード切替試行中か（true: 試行中） */
  isTryingToSwitchOnline: boolean
  /** オフラインモード切替試行中か（true: 試行中） */
  isTryingToSwitchOffline: boolean
}

export const useNetworkStore = defineStore('networkStore', {
  state: (): NetworkState => ({
    /** オンライン状態か（true: オンライン状態） */
    isOnline: true,
    /** オンラインになれる状態か（true: オンラインになれる状態） */
    canConnectNetwork: true,
    /** オンラインモード切替試行中か（true: 試行中） */
    isTryingToSwitchOnline: false,
    /** オフラインモード切替試行中か（true: 試行中） */
    isTryingToSwitchOffline: false
  }),

  getters: {
    getIsOnline: state => state.isOnline,
    getCanConnectNetwork: state => state.canConnectNetwork,
    getIsTryingToSwitchOnline: state => state.isTryingToSwitchOnline,
    getIsTryingToSwitchOffline: state => state.isTryingToSwitchOffline
  },

  actions: {
    /**
     * システムをオンライン状態にする
     * オンラインにする前にヘルスチェックを実行し、
     *  - 成功: システムをオンラインにする
     *  - 失敗: システムをオフラインのままにする
     * という処理を行う
     * @param なし
     * @returns なし
     */
    async setOnlineStatus() {
      // 既にオンラインなら何もしない
      if (this.getIsOnline) return

      // オフラインからオンラインへの変更処理
      await (this.isTryingToSwitchOnline = true) // 接続中フラグを立てる
      this.isOnline = (await isOnlineByHealthChecker()) ? true : false

      this.isTryingToSwitchOnline = false // 接続中フラグを解除
    },

    /**
     * システムをオフライン状態にする
     * @param なし
     * @returns なし
     */
    async setOfflineStatus() {
      // 既にオフラインなら何もしない
      if (!this.getIsOnline) return
      await (this.isTryingToSwitchOffline = true)
      this.isOnline = false
      this.isTryingToSwitchOffline = false
    },

    /**
     * オンラインになれる状態かどうかを更新する
     */
    setCanConnectNetwork(canConnectNetwork: boolean) {
      this.canConnectNetwork = canConnectNetwork
    }
  }
})
